<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>
              Daily Verses for {{ getMonthName(dailyVerseSort.selectedMonth) }}
            </h4>
            <h6>Manage daily verses</h6>
          </div>
        </div>
        <ul class="table-top-head">
          <li>
            <a
                ref="collapseHeader"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Collapse"
                @click="toggleCollapse(collapseHeader)"
            >
              <i data-feather="chevron-up" class="feather-chevron-up"></i>
            </a>
          </li>
        </ul>
        <div class="page-btn">
          <a
              href="javascript:void(0);"
              class="btn btn-added"
              @click="toggleDatePicker()"
          >
            <vue-feather type="plus-circle" class="me-2"></vue-feather>
            {{ isAboutAddNew ? "Cancel" : "Add New Daily Verse" }}
          </a>
        </div>
        <div class="page-btn" v-if="isAboutAddNew">
          <a-date-picker
              open
              :style="{ height: '38px', width: '171px' }"
              @change="addNewDailyVerse($event.$d)"
          />
        </div>
      </div>
      <!-- /product list -->
      <div class="card">
        <div class="card-body pb-0">
          <div class="table-top table-top-new">
            <div class="search-set mb-0">

              <div class="search-input">
                <a href="" class="btn btn-searchset"
                ><i data-feather="search" class="feather-search"></i
                ></a>
                <input type="search" class="form-control" v-model="filter" />
              </div>
            </div>
            <div
                class="search-path d-flex align-items-center search-path-new gap-2"
            >
              <div class="form-sort">
                <vue-feather type="sliders" class="info-img"></vue-feather>
                <vue-select
                    v-model="dailyVerseSort.selectedYear"
                    :options="dailyVerseSort.years"
                    id="sort2"
                    placeholder="Select Year"
                    @select="yearSelected()"
                />
              </div>
              <div class="form-sort">
                <vue-feather type="sliders" class="info-img"></vue-feather>
                <div class="tooltip" id="yearTooltip"></div>
                <vue-select
                    v-model="dailyVerseSort.selectedMonth"
                    :options="dailyVerseSort.months"
                    id="monthSelect"
                    placeholder="Select Month"
                    @select="loadMonthDailyVerse()"
                    ref="monthSelect"
                >
                </vue-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /product list -->



      <div class="employee-grid-widget">
        <div></div>

        <a-list
            v-if="showList"
            :pagination="pagination"
            :grid="{ gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 5 }"
            :data-source="monthDailyVerse"
        >
          <template #renderItem="{ item }">
            <DailyVerseCard
                @dailyVerseCopied="copyDailyVerse"
                :dailyVerse="item.verse"
                :date="item.date"
            />

          </template>

        </a-list>
        <div v-else>
          <h4 class="text-center">{{ listMessage }}</h4>
        </div>
      </div>
    </div>
  </div>
  <AddDailyVerseModal />
  <div class="copy-step">
    <i class="icon-arrow-right"></i>
  </div>


</template>

<script setup>
import { generateNumberList, getMonthName } from "@/utils";
import { computed, onMounted, reactive, ref, watch } from "vue";

import { useDevotionStore } from "@/store/devotionStore";
import { toggleCollapse } from "@/utils/components";
import AddDailyVerseModal from "./modal/add-dailyVerse-modal.vue";
import { useRouter } from "vue-router";
import { encodeUrlData, years } from "./utils/data";
import {useDailyVerseStore} from "@/store/dailyVerseStore";
import DailyVerseCard from "./components/daily-verse-card.vue";

// hooks
const router = useRouter();
// STOREs
const dailyVerseStore = useDailyVerseStore();

// HTML REFs
const collapseHeader = ref(null);
const monthSelect = ref(null);

// DATA
const isAboutAddNew = ref(false);
const todayDate = new Date();
const showList = ref(true);
const filter = ref("");
const copiedDailyVerse = ref(null);
/** Message to show the user when the list is hidden */
const listMessage = ref(null);
const pagination = {
  onChange: (page) => {},
  pageSize: 12,
};

/** All Data for sorting the Devotional */
// const dailyVerseSort = reactive({
//   selectedYear: ref(todayDate.getFullYear()),
//   selectedMonth: ref(todayDate.getMonth()),
//   years: years(),
//   months: generateNumberList(0, 11).map((number) => ({
//     text: getMonthName(number),
//     id: Number.parseInt(number),
//   })),
// });

const dailyVerseSort = reactive({
  selectedYear: todayDate.getFullYear(),
  selectedMonth: todayDate.getMonth(),
  years: years(),
  months: generateNumberList(0, 11).map((number) => ({
    text: getMonthName(number),
    id: Number.parseInt(number),
  })),
});

/** Devotional for the selected Year and Month */
const monthDailyVerse = computed(() => {
  let dailyVerses = [
    ...dailyVerseStore.loadDailyVersesByMonth(
        dailyVerseSort.selectedYear,
        dailyVerseSort.selectedMonth
    ),
  ];
  if (!!filter.value) {
    dailyVerses = dailyVerses.filter((item) =>
        (item.dailyVerse?.bible_verse ?? "")
            .toLowerCase()
            .includes(filter.value.toLowerCase())
    );
  }
  return dailyVerses;
});

function toggleDatePicker() {
  isAboutAddNew.value = !isAboutAddNew.value;
}

function copyDailyVerse(devotion) {
  copiedDailyVerse.value = devotion;
  isAboutAddNew.value = true;
}
function addNewDailyVerse(pickedDate) {
  const date = pickedDate.toISOString().slice(0, 10);
  const encodedData = encodeUrlData(date);
  router.push({
    name: "add-edit-daily-verse",
    params: {
      action: "add",
      encodedData: encodedData,
    },
  });
}
/** Load the Devotional for the selected Month */
async function loadMonthDailyVerse() {
  showList.value = true;

  const query = {
    year: dailyVerseSort.selectedYear,
    month: dailyVerseSort.selectedMonth,
  };
  await dailyVerseStore.fetchDailyVerseByMonth(query);
}

/** Inform the User to Select a Month */
function yearSelected() {
  showList.value = false;
  dailyVerseSort.selectedMonth = null;
  listMessage.value = "Select a Month to Fetch the Daily Verses";
}
onMounted(() => {
  if (monthDailyVerse.value.length == 0) {
    loadMonthDailyVerse();
  }
});

</script>

<style>

</style>